import {SERVER_URL} from "../utils/Constants";
import GeneralUtils from "../utils/GeneralUtils";
import ServiceMember from "./ServiceMember";

export default class MemberUserNotesService extends ServiceMember {
    constructor() {
        super();
        this.baseURL = 'security/user/member/notes';
    }


    async getNotesAndAllergies() {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL , {
            headers: {
                'Content-Type': 'application/json',
            },
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    async updateWithoutNotification( orderNotes, allergies) {
        let data = {
            orderNotes:orderNotes,
            allergies:allergies
        };
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL, {
            crossDomain: true,
            method: 'put',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data)
        }).then(response => {
            let result = response.clone();
            return GeneralUtils.responseToJson(result);
        }).catch(error => {
        });
    }



}